.searchbar {
	margin: 4px 0;
	padding-inline: 4px;
	width: 100% !important;
	background-color: var(--elevation-default);
}

.searchbar input {
	border-radius: 8px !important;
	border: none;
	border: var(--border-primary) 1px solid;
	background-color: var(--elevation-default) !important;
	height: 40px;
	outline-offset: -2px;
}

.option,
.loading,
.empty {
	padding: 12px;
	color: var(--content-primary);
	composes: body-2 from global;
}

.option {
	cursor: pointer;
}

.option:hover {
	background-color: var(--elevation-medium);
}
